import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

// PDF oluşturucu iframe'inin yükleneceği URL ve güvenlik token'ı
const PDF_GENERATOR_URL = 'https://littlehibba.com/admin/api.php';
const PDF_SECRET_TOKEN = 'LH-PDF-Gen-Token-84a2d9b1-3e4f-4b6c-8e1d-5a9f2b7c6d0e';

function PdfGenerationModal({ show, order, onHide, onSuccess, apiBaseUrl }) {
    const [isProcessing, setIsProcessing] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let pollingInterval = null;

        // Modal gösterildiğinde ve bir sipariş olduğunda işlemi başlat
        if (show && order) {
            // State'leri başlangıç durumuna getir
            setIsProcessing(true);
            setIsComplete(false);
            setError(null);

            // Sunucudaki sipariş durumunu her 3 saniyede bir kontrol et (polling)
            pollingInterval = setInterval(async () => {
                try {
                    const response = await axios.get(`${apiBaseUrl}/index.php?action=getOrderStatus&orderId=${order.id}`);
                    const currentStatus = String(response.data.data.order_status);

                    // Eğer durum '2' (Send to Test) olduysa, işlem tamamlanmıştır.
                    if (currentStatus === '2') {
                        setIsComplete(true);
                        setIsProcessing(false);
                        clearInterval(pollingInterval); // Kontrol etmeyi durdur
                        
                        // Başarı mesajını 2 saniye gösterdikten sonra modalı kapat ve listeyi yenile
                        setTimeout(onSuccess, 2000); 
                    }
                } catch (err) {
                    console.error('Order status polling failed:', err);
                    setError('An error occurred while checking the order status.');
                    clearInterval(pollingInterval); // Hata durumunda da kontrolü durdur
                }
            }, 3000); // 3 saniyede bir kontrol et
        }

        // Komponent kaldırıldığında veya modal kapandığında interval'i temizle
        return () => {
            if (pollingInterval) {
                clearInterval(pollingInterval);
            }
        };
    }, [show, order, apiBaseUrl, onSuccess]);

    // Eğer sipariş verisi yoksa hiçbir şey render etme
    if (!order) return null;

    // iframe'in kaynak URL'si. Sunucuya isteğin React'ten geldiğini bildirmek için '&client=react' ekliyoruz.
    const iframeSrc = `${PDF_GENERATOR_URL}?orderID=${order.order_id}&token=${PDF_SECRET_TOKEN}&client=react`;

    return (
        <Modal show={show} onHide={onHide} size="xl" centered backdrop="static" keyboard={false}>
            <Modal.Header closeButton={isComplete || !!error}>
                <Modal.Title>
                    {isComplete ? 'Process Complete' : `Generating PDF for Order #${order.order_id}`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '80vh', position: 'relative' }}>

                {isComplete ? (
                    <Alert variant="success" className="h-100 d-flex flex-column justify-content-center align-items-center text-center">
                        <Alert.Heading>Success!</Alert.Heading>
                        <p>The PDF has been generated and the order status has been updated.</p>
                        <p className="mb-0">This window will close automatically.</p>
                    </Alert>
                ) : error ? (
                     <Alert variant="danger" className="h-100 d-flex flex-column justify-content-center align-items-center text-center">
                        <Alert.Heading>An Error Occurred</Alert.Heading>
                        <p>{error}</p>
                        <p className="mb-0">Please close this window and try again.</p>
                    </Alert>
                ) : (
                    <>
                        <div className="text-center mb-3">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2 mb-0">PDF generation is in progress...</p>
                            <small className="text-muted">This may take a moment. The window will close automatically upon completion.</small>
                        </div>
                        <iframe
                            src={iframeSrc}
                            title="PDF Generator"
                            style={{ width: '100%', height: 'calc(100% - 70px)', border: '1px solid #dee2e6' }}
                            sandbox="allow-scripts allow-same-origin allow-forms" // Güvenlik için sandbox özellikleri
                        />
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default PdfGenerationModal;